module.exports = __webpack_public_path__ + "static/media/sprite_3.7cc7d512.png";